import { OrderFormValues } from '../typings'

type OrderType = OrderFormValues['type']

interface OrderTypeVisibility {
  pickupAndDeliveryFromStart: boolean
  showPickupAndDelivery: boolean
  showPickup: boolean
  showDelivery: boolean
}

export function getOrderTypeVisibility(
  initialType: OrderType,
  currentType: OrderType,
): OrderTypeVisibility {
  return {
    pickupAndDeliveryFromStart: initialType === 'pd',
    showPickupAndDelivery: currentType === 'pd',
    showPickup: currentType === 'p',
    showDelivery: currentType === 'd' || currentType === 's',
  }
}
